<template>
  <div class="content_check" :class="classDiv">
    <label class="custom-checkbox">
    <input
      type='checkbox'
      :id= id_index
      :class=classNames
      :style=styleNames
      :checked=value
      :disabled="disabled"
      @input="$emit('input', $event.target.checked)"
      @change="onInputChange"
    />
  <span></span>
</label>
  </div>
</template>

<script>
export default {
  name: "input-checkbox",
  props: {
    id: { type: String},
    value: { type: [Boolean, Function]},
    classNames: { type: String},
    styleNames: { type: [String, Object]},
    classDiv: { type: String },
    onChange: { type: Function },
    index: { type: Number},
    disabled: {type: Boolean}
  },

  data() {
    return{
      id_index: this.id + '_' + this.index
    }
  },

  methods: {
    onInputChange: function(event) {
      if(this.onChange) this.onChange(event.target.checked);
    }
  }
}

</script>

<style lang="scss" scoped>
  .custom-checkbox {
    margin: 0;
    
    input {
      display: none;

      &[disabled] + span,
      &[disabled]:checked + span {
        background-color: #ccc;
        color: $off-white;
        border-color: #ccc;
        cursor: default;
      }
    }

    span {
      border: 1px solid #CCC;
      float: left;
      height: 14px;
      width: 14px;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:hover span {
      border: 1px solid darken(#CCC, 15%);
    }

    input:checked + span {
      border: 1px solid #ec9148;
      background: #ec9148;
      color: white !important;
      position: relative;

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        content: "\F00C"!important;
        color: #fff;
        font-size: 10px;
        line-height: 13px;
        width: 12px;
        text-align: center;
      }
    }
  }
</style>
